import { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import { getShops, saveEditMemberNote } from "actions/shopActions";
import { getStaffs } from "actions/teamActions";
import { formatterCreateAt } from "components/Function";
import { ReactTable } from "components/Table";
import Loading from "components/Loading";
import SelectBox from "components/elements/selectBox";
import ModalChangeWarehouse from "./modalChangeWarehouse";
import ModalChangeResponsiblePerson from "./modalChangeResponsiblePerson";
import { Link } from "react-router-dom";

function ShopList(props) {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [toggleCard, setToggleCard] = useState(false);
    const [filter, setFilter] = useState({});
    const [staffs, setStaffs] = useState([]);
    const [isOpenModalChangeWarehouse, setIsOpenModalChangeWarehouse] = useState(false);
    const [changeWarehouse, setChangeWarehouse] = useState([]);
    const [isOpenModalChangeResponsiblePerson, setIsOpenModalChangeResponsiblePerson] = useState(false);
    const [changeResponsiblePerson, setChangeResponsiblePerson] = useState([]);

    const { t } = useTranslation();
    var { list, totalsize, isLoading } = props.shop;
    var { getShops, shops_selected, setShopsSelected, getStaffs, saveEditMemberNote } = props;

    useEffect(() => {
        getShops({ page, sizeperpage: sizePerPage, search: searchText, filter });
    }, [getShops, page, sizePerPage, searchText, filter]);

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    useEffect(() => {
        getStaffs({ sizeperpage: 100 }).then((data) => {
            setStaffs(data?.data?.map((staff) => ({ value: staff?.user?._id, label: staff.user.email + " - " + staff?.user?.name })) || []);
        });
    }, [getStaffs]);

    const handleBeforeSaveCell = (oldValue, newValue, row, column) => {
        saveEditMemberNote({ _id: row._id, [column.dataField]: newValue, page, sizePerPage, searchText });
    }

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            editable: false,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "apiShopId",
            text: t("Shop ID"),
            editable: false,
            sort: true,
        },
        {
            dataField: "name",
            text: t("Shop Name"),
            editable: false,
            sort: true,
        },
        {
            dataField: "orders_count",
            text: t("Total Order"),
            editable: false,
            sort: true,
        },
        {
            dataField: "products_count",
            text: t("Total Product"),
            editable: false,
            sort: true,
        },
        {
            dataField: "note",
            text: t("Note"),
            editable: false,
            sort: true,
        },
        {
            dataField: "member_note",
            text: t("Member Note"),
            sort: true,
            formatter: (cell, row, rowIndex) => <Fragment>{cell} <i className="ki-outline ki-notepad-edit fs-2 align-bottom cursor-pointer"></i></Fragment>,
        },
        {
            dataField: "region",
            text: t("Region"),
            editable: false,
            sort: true,
        },
        {
            dataField: "warehouses",
            text: t("Warehouses"),
            editable: false,
            sort: true,
            formatter: (cell, row, rowIndex, formatExtraData) => <Fragment><i className="ki-outline ki-bank fs-2 align-bottom cursor-pointer" data-tooltip-id="my-tooltip"
                data-tooltip-content={"Change Default Warehouse"} onClick={() => { onClickOpenModalChangeWarehouse(row, formatExtraData) }} ></i>
                <i className="fa fa-user fs-2 align-bottom cursor-pointer ms-5" data-tooltip-id="my-tooltip"
                    data-tooltip-content={"Change Default Responsible Person"} onClick={() => { onClickOpenModalChangeResponsiblePerson(row, formatExtraData) }} ></i>
                <Link to="/admin/shops/warehouses" target="_blank" hidden="true">
                    <i className="ki-outline ki-pencil fs-2 align-bottom cursor-pointer ms-5" data-tooltip-id="my-tooltip"
                        data-tooltip-content={"Add/Edit Warehouse"}></i>
                </Link>
                <Link to="/admin/shops/shipping-template" target="_blank" hidden="true">
                    <i className="ki-outline ki-delivery-2 fs-2 align-bottom cursor-pointer ms-5" data-tooltip-id="my-tooltip"
                        data-tooltip-content={"Shipping Template"}></i>
                </Link>
            </Fragment>,

        },
    ];

    const sizePerPageList = [
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "200",
            value: 200,
        },
        {
            text: "All",
            value: totalsize || 10,
        },
    ];

    const groupButton = () => {
        return (
            <>
                <div className="mb-5 d-flex justify-content-between">
                    <SelectBox
                        options={staffs}
                        name="filter_staff"
                        value={filter.staff || ""}
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                staff: data.value || "",
                            }));
                            setPage(1);
                        }}
                    />
                </div>
            </>
        );
    };

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    // const removeSelect = (arr, value) => {
    //     var i = 0;
    //     while (i < arr.length) {
    //         if (arr[i] === value) {
    //             arr.splice(i, 1);
    //         } else {
    //             ++i;
    //         }
    //     }
    //     return arr;
    // };

    const onClickOpenModalChangeWarehouse = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText
            }
        }
        setIsOpenModalChangeWarehouse(!isOpenModalChangeWarehouse);
        setChangeWarehouse(row);
    }

    const onClickOpenModalChangeResponsiblePerson = (row = [], formatExtraData) => {
        if (typeof formatExtraData !== "undefined") {
            row = {
                ...row,
                page: formatExtraData.page,
                sizePerPage: formatExtraData.sizePerPage,
                searchText: formatExtraData.searchText
            }
        }
        setIsOpenModalChangeResponsiblePerson(!isOpenModalChangeResponsiblePerson);
        setChangeResponsiblePerson(row);
    }

    const onSelect = (row, isSelect) => {
        if (isSelect) {
            setShopsSelected((prev) => [...prev, row._id]);
        } else {
            setShopsSelected((prev) => [...prev].filter((d) => d !== row._id));
        }
    };

    const onSelectAll = (checked, row) => {
        let selects = [];
        if (checked) selects = (row || []).map((s) => s._id);
        setShopsSelected(selects);
    };

    const selectRow = {
        mode: "checkbox",
        clickToSelect: false,
        selected: shops_selected,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
            <div className="d-flex">
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) {
                            input.indeterminate = indeterminate;
                            input.checked = checked;
                        }
                    }}
                    onChange={onChange}
                />
                <span style={{ marginLeft: '8px' }}>({shops_selected.length})</span>
            </div>
        ),
    };

    return (
        <Fragment>
            <Loading isLoading={isLoading} />
            <div className="card mb-5 mb-xl-10">
                <div
                    className={cx("card-header collapsible cursor-pointer rotate", {
                        active: !toggleCard,
                        collapsed: toggleCard,
                    })}
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_docs_card_collapsible"
                    onClick={() => setToggleCard(!toggleCard)}
                >
                    <h3 className="card-title">{t("List Shops")}</h3>
                    <div className="card-toolbar rotate-180">
                        <i className="ki-duotone ki-down fs-1"></i>
                    </div>
                </div>
                <div id="kt_docs_card_collapsible" className={cx("collapse", { show: !toggleCard })}>
                    <div className="card-body p-9">
                        <div className="al-variants-table">
                            <ReactTable
                                columns={columns}
                                data={list}
                                groupButton={groupButton}
                                handleTableChange={handleTableChange}
                                page={page}
                                sizePerPage={sizePerPage}
                                totalSize={totalSize}
                                alClassName="table-layout-inherit"
                                isSelectRow={true}
                                selectRow={selectRow}
                                sizePerPageList={sizePerPageList}
                                isCellEdit={true}
                                handleBeforeSaveCell={handleBeforeSaveCell}
                            />
                        </div>
                    </div>
                </div>
                {isOpenModalChangeWarehouse ? <ModalChangeWarehouse openModal={onClickOpenModalChangeWarehouse} isOpenModalChangeWarehouse={isOpenModalChangeWarehouse} changeWarehouse={changeWarehouse} /> : ''}
                {isOpenModalChangeResponsiblePerson ? <ModalChangeResponsiblePerson openModal={onClickOpenModalChangeResponsiblePerson} isOpenModalChangeResponsiblePerson={isOpenModalChangeResponsiblePerson} changeResponsiblePerson={changeResponsiblePerson} /> : ''}
            </div>
        </Fragment>
    );
}

ShopList.propTypes = {
    getStaffs: PropTypes.func.isRequired,
    saveEditMemberNote: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
    shop: state.shop,
});
const mapDispatchToProps = {
    formatterCreateAt,
    getShops,
    getStaffs,
    saveEditMemberNote,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopList);
